import {useSnackbar} from "notistack";
import {useQuery} from '@tanstack/react-query';
import {getSearchFile} from "../../api/queries";
import {ActionButton} from "../common";
import DownloadIcon from "../../icons/Download";

const DeviceSearchDownloadButton = ({ queryParams, bodyParams }) => {
  const { enqueueSnackbar } = useSnackbar();

  const query = useQuery({
    queryKey: [getSearchFile.key],
    queryFn: () => getSearchFile.func(queryParams, bodyParams),
    enabled: false,
  });

  const handleDownload = async () => {
    const result = await query.refetch();
    if (result.isSuccess) {
      const { blob, filename } = result.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } else {
      console.error(result.error);
      enqueueSnackbar('Download failed.', {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'top'
        },
        variant: 'error'
      });
    }
  };

  return (

      <ActionButton
        label={
          <>
            <DownloadIcon fontSize="small" />
            Download
          </>
        }
        action={handleDownload}
      />
  );
};

export default DeviceSearchDownloadButton;